<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button
          type="merge"
          @click="updateAll()"
          :text="$t('notificationtemplates.update_existing')"
          color="warning"
          v-if="notificationtemplate.id && !notificationtemplate.is_local && from_module != 'coursetemplate'"
        />
        <action-button type="view" @click="showPreview = true" :text="$t('global.preview')" color="info" />
        <action-button type="save" @click="save" v-if="$can('notificationtemplate-edit')" />
        <action-button
          type="delete"
          @click="del(notificationtemplate.id)"
          v-if="$can('notificationtemplate-delete') && notificationtemplate.is_local"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-menu :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="fab-tags darken-2 pa-1 text--white" small absolute top right icon
                  ><v-icon>format_list_bulleted</v-icon>
                </v-btn>
              </template>
              <v-card width="400px">
                <v-card-text>
                  <v-simple-table dense>
                    <tbody>
                      <tr>
                        <td colspan="2" class="text-center">
                          <b>{{ $t("notificationtemplates.available_tags") }}</b>
                        </td>
                      </tr>
                      <tr v-for="(value, key) in tags" :key="key">
                        <td class="pa-1" style="white-space: nowrap">
                          <!--<v-chip small color="primary">{{ key }}</v-chip>-->{{ "{" + key + "}" }}
                        </td>
                        <td class="pa-1" style="border-left: 1px solid rgba(0, 0, 0, 0.2)">{{ value }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-menu>

            <v-layout row wrap>
              <v-flex xs12 v-if="coursetemplate_id">
                <v-autocomplete
                  name="notificationtemplate.coursetemplate_id"
                  v-model="notificationtemplate.coursetemplate_id"
                  :items="coursetemplates"
                  item-text="name"
                  item-value="id"
                  :label="$t('notificationtemplates.coursetemplate_id')"
                  autocomplete="new-password"
                  :readonly="true"
                ></v-autocomplete>
              </v-flex>
              <v-flex md11 xs12>
                <v-text-field
                  name="notificationtemplate.subject"
                  v-model="notificationtemplate.subject"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('notificationtemplates.subject')"
                  :error-messages="errors.collect('notificationtemplate.subject')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md1 xs12>
                <v-text-field
                  name="notificationtemplate.type"
                  :value="notificationtemplate.type ? $dd_notification_template_type(notificationtemplate.type) : ''"
                  :label="$t('notificationtemplates.type')"
                  :readonly="true"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div v-if="notificationtemplate.type == 'sms'">
                  <v-textarea
                    name="notificationtemplate.template"
                    class="required-field sms-textarea"
                    v-validate="'required|dynamicMax:320,' + smsCounter.count"
                    v-model="notificationtemplate.template"
                    :label="$t('notificationtemplates.template')"
                    :error-messages="errors.collect('notificationtemplate.template')"
                    :auto-grow="true"
                    :hint="smsCounter.html"
                    :persistent-hint="true"
                  >
                    <template v-slot:message="{ message, key }">
                      <span v-html="message"></span>
                    </template>
                  </v-textarea>
                </div>
                <div v-if="notificationtemplate.type == 'email'">
                  <div class="required-field mb-1">{{ $t("notificationtemplates.template") }}</div>
                  <vue-editor
                    name="notificationtemplate.template"
                    class="vue2editor"
                    :editor-toolbar="customToolbar"
                    v-validate="'required'"
                    v-model="notificationtemplate.template"
                    :error-messages="errors.collect('notificationtemplate.template')"
                  ></vue-editor>
                  <div class="v-text-field__details mt-2">
                    <div class="v-messages theme--light error--text" role="alert">
                      <div class="v-messages__wrapper">
                        <div class="v-messages__message">{{ errors.first("notificationtemplate.template") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="notificationtemplate.description"
                  class="required-field"
                  v-validate="'required'"
                  v-model="notificationtemplate.description"
                  :label="$t('notificationtemplates.description')"
                  :error-messages="errors.collect('notificationtemplate.description')"
                  :auto-grow="true"
                  :rows="2"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 v-if="notificationtemplate.type == 'email'">
                <v-autocomplete
                  name="notificationtemplate.trigger"
                  v-model="notificationtemplate.trigger"
                  item-text="name"
                  item-value="slug"
                  :items="computedTriggers"
                  :label="$t('notificationtemplates.trigger')"
                  :error-messages="errors.collect('notificationtemplate.trigger')"
                  autocomplete="new-password"
                  :disabled="!notificationtemplate.is_local"
                  @change="triggerChange"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="notificationtemplate.status"
                  v-model="notificationtemplate.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_notification_template_status()"
                  :label="$t('notificationtemplates.status')"
                  :error-messages="errors.collect('notificationtemplate.status')"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog v-model="showPreview" persistent max-width="570px">
        <v-card>
          <v-card-text>
            <div class="preview-box" v-html="notificationtemplate.template"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <action-button type="cancel" @click="showPreview = false" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor"
export default {
  name: "notificationtemplateForm",

  props: ["id", "coursetemplate_id"],

  components: { VueEditor },

  data() {
    return {
      page_title: "",
      predata: {},

      api_module: "",
      from_module: "",
      type: "",

      organisation: null,

      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ list: "ordered" }, { list: "bullet" }]
      ],

      showPreview: false,
      triggers: [],

      notificationtemplate: {
        template: ""
      },
      coursetemplates: [],
      tags: [],

      dictionary: {
        attributes: {
          "notificationtemplate.subject": this.$t("notificationtemplates.subject"),
          "notificationtemplate.template": this.$t("notificationtemplates.template"),
          "notificationtemplate.description": this.$t("notificationtemplates.description"),
          "notificationtemplate.trigger": this.$t("notificationtemplates.trigger"),
          "notificationtemplate.status": this.$t("notificationtemplates.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.notificationtemplate, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    smsCounter() {
      return this.$smsCounter(this.notificationtemplate.template, [
        { tag: "{organisation_name}", count: this.organisation.name ? this.organisation.name.length : 0 }
      ])
    },
    locale() {
      let locale = this.$getSetting("locale")
      return locale ? locale : "no"
    },
    computedTriggers() {
      let data = this.triggers

      if (this.locale == "no") {
        data.forEach((item, index) => {
          item.name = item.name_no
        })
      }

      return data
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.from_module = this.$route.query.from_module
    this.type = this.$route.query.type || "email"

    if (this.from_module == "coursetemplate") {
      this.api_module = "coursetemplatenotificationtemplate"
    } else {
      this.api_module = "notificationtemplate"
    }

    axios
      .post(this.API_URL + "request/ddlists", [
        { key: "organisation", module: "organisation", query: "resourcetype=basic" },
        { key: "coursetemplates", module: "coursetemplates", query: "show_all=true" },
        { key: "notificationtemplatestriggers", module: "notificationtemplatestriggers", query: "" }
      ])
      .then((res) => {
        this.coursetemplates = res.data.coursetemplates
        this.organisation = res.data.organisation
        this.triggers = res.data.notificationtemplatestriggers

        if (!this.id) {
          this.page_title = this.$t("notificationtemplates.create_title")
          this.notificationtemplate.type = this.type
          this.notificationtemplate.is_local = 1
          this.notificationtemplate.status = 1
          this.notificationtemplate.tags = this.$getGenericCourseEmailSMSTags(this.type)
          this.tags = this.notificationtemplate.tags
          this.predata = JSON.parse(JSON.stringify(this.notificationtemplate))
        } else {
          this.title = this.$t("notificationtemplates.update_title")

          axios
            .get(this.API_URL + this.api_module + "/" + this.id)
            .then((res) => {
              this.notificationtemplate = res.data.data
              this.tags = this.notificationtemplate.tags

              // JSON stringify and parse to remove variable reactiveness
              this.predata = JSON.parse(JSON.stringify(this.notificationtemplate))

              this.page_title = this.$t("notificationtemplates.edit_notificationtemplate", {
                name: this.notificationtemplate.subject
              })
            })
            .catch((err) => console.log(err))
        }
      })
  },

  methods: {
    updateAll() {
      let vm = this

      this.$awn.confirm(
        this.$t("notificationtemplates.update_existing_confirm"),
        () => {
          axios
            .put(this.API_URL + "notificationtemplate/update-all", {
              id: this.notificationtemplate.id
            })
            .then((res) => {
              if (res.data.status == "success") {
                vm.$awn.success(vm.$t("global.update_success"))
              } else {
                vm.$awn.success(vm.$t("global.update_failed"))
              }
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.no"),
            confirmOk: this.$t("global.yes")
          }
        }
      )
    },
    preview() {},
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.notificationtemplate.id) {
              // Create
              axios
                .post(this.API_URL + this.api_module, {
                  coursetemplate_id: this.notificationtemplate.coursetemplate_id,
                  slug: this.notificationtemplate.slug,
                  subject: this.notificationtemplate.subject,
                  template: this.notificationtemplate.template,
                  description: this.notificationtemplate.description,
                  tags: this.notificationtemplate.tags,
                  trigger: this.notificationtemplate.trigger,
                  type: this.notificationtemplate.type,
                  status: this.notificationtemplate.status
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.notificationtemplate = res.data.data
                      vm.tags = vm.notificationtemplate.tags
                      vm.predata = JSON.parse(JSON.stringify(vm.notificationtemplate))

                      vm.page_title = this.$t("notificationtemplates.edit_notificationtemplate", {
                        name: this.notificationtemplate.subject
                      })

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/notificationtemplates/edit/${vm.notificationtemplate.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + this.api_module, {
                  id: this.notificationtemplate.id,
                  coursetemplate_id: this.notificationtemplate.coursetemplate_id,
                  slug: this.notificationtemplate.slug,
                  subject: this.notificationtemplate.subject,
                  template: this.notificationtemplate.template,
                  description: this.notificationtemplate.description,
                  trigger: this.notificationtemplate.trigger,
                  type: this.notificationtemplate.type,
                  status: this.notificationtemplate.status
                })
                .then((res) => {
                  vm.notificationtemplate = res.data.data
                  vm.tags = vm.notificationtemplate.tags
                  vm.predata = JSON.parse(JSON.stringify(vm.notificationtemplate))

                  vm.page_title = this.$t("notificationtemplates.edit_notificationtemplate", {
                    name: this.notificationtemplate.subject
                  })

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "notificationtemplate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/notificationtemplates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    triggerChange() {
      if(this.notificationtemplate.trigger) {
        let obj = this.triggers.find(i => i.slug == this.notificationtemplate.trigger)
        if(obj) {
          this.notificationtemplate.tags = obj.tags
        }
      } else {
        this.notificationtemplate.tags = this.$getGenericCourseEmailSMSTags(this.notificationtemplate.type)
      }

      this.tags = this.notificationtemplate.tags
    }
  }
}
</script>

<style>
.fab-tags {
  top: 5px !important;
  right: 0px !important;
  background-color: var(--v-primary-darken2) !important;
  color: var(--v-button_text-base) !important;
}
.vue2editor .ql-editor {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.preview-box {
  padding: 20px !important;
}
.preview-box p {
  margin: 0 !important;
}
.sms-textarea .v-messages.error--text {
  text-align: left !important;
}
.sms-textarea .v-messages {
  text-align: right !important;
}
</style>
